import { capitalize } from "lodash";

export const desluggify = (slug: string, sep = "-") => {
  return slug
    .split(sep)
    .map((word) => capitalize(word))
    .join(" ");
};
